import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";

@Component({
  selector: 'app-item-invite-user-detail-dialog',
  templateUrl: './item-invite-user-detail-dialog.component.html',
  styleUrls: ['./item-invite-user-detail-dialog.component.css']
})
export class ItemInviteUserDetailDialogComponent implements OnInit {

  user: any;

  constructor(
    public dialogRef: MdDialogRef<ItemInviteUserDetailDialogComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    this.user = data.user;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-invite-user-detail-dialog/item-invite-user-detail-dialog.component.ts